import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PLinkModule } from '@panaya/ui/p-link';
import { NgLetModule } from 'ng-let';
import { PExpandAreaTriggerComponent } from './p-expand-area-trigger.component';

@NgModule({
    declarations: [PExpandAreaTriggerComponent],
    imports: [CommonModule, NgLetModule, PLinkModule, TranslateModule],
    exports: [PExpandAreaTriggerComponent]
})
export class PExpandAreaTriggerModule {}
